/** Retired on both surfaces by owner decision, 2026-09-29. Keep the reversible
 * switch and historical analytics; do not mount or fetch the recipe feature. */
export const MEAL_IDEAS_ENABLED = false;

export function mealIdeasAllowed(catalogReady: boolean): boolean {
  return MEAL_IDEAS_ENABLED && catalogReady === true;
}
